import script from "./CatalogProduct.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogProduct.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogProduct.vue?vue&type=style&index=0&id=1f8e04c1&scoped=true&lang=css"
import "./CatalogProduct.vue?vue&type=style&index=1&id=1f8e04c1&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f8e04c1"]])

export default __exports__